import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[raptorAutotab]'
})
export class RaptorAutotabDirective {

  constructor() {}

  @HostListener('input', ['$event.target']) onInput(input: any) {
    const valueLength = input.value.length;
    const maxLength = input.attributes.maxlength.value;
    let inputIndex;
    let nextElement;

    if (valueLength >= maxLength) {
      // find the next auto tab
      // typecast as node list of html elements
      let focusableElements = <NodeListOf<HTMLElement>>document.querySelectorAll('input,select,textarea,button,[tabindex]');

      for (let i = 0; i < focusableElements.length; i += 1) {
        if (focusableElements[i] === input) {
          inputIndex = i;
        }
      }
      if (inputIndex) {
        nextElement = focusableElements[inputIndex + 1];
      }

      if (inputIndex && inputIndex > -1 && nextElement) {
        nextElement.focus()
      } else {
        input.blur();
      }
    }
  }
}
